import * as React from 'react';
import { cn } from '../../lib/shadcn-utils';

const Card = React.forwardRef(({ as: Comp = 'div', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
Card.displayName = 'Card';

const CardHeader = React.forwardRef(({ as: Comp = 'div', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef(({ as: Comp = 'h3', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef(({ as: Comp = 'p', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
CardDescription.displayName = 'CardDescription';

const CardContent = React.forwardRef(({ as: Comp = 'div', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
CardContent.displayName = 'CardContent';

const CardFooter = React.forwardRef(({ as: Comp = 'div', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
CardFooter.displayName = 'CardFooter';

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
